import { Form, FormInstance, Input } from 'antd'
import { useEffect, useState } from 'react'
import { debounce } from 'utils/common'

import Editor from 'components/features/editor/QuillEditor'
import Tags from 'components/features/tag'

interface IFormContentProps {
  form: FormInstance
  lang: string
  dataSource: any
}

const FormContent = ({ form, lang, dataSource }: IFormContentProps) => {
  const [content, setContent] = useState<string>()

  useEffect(() => {
    if (dataSource?.id && dataSource?.articleId) {
      form.setFieldValue(lang, dataSource)
      setContent(dataSource.content)
    } else {
      setContent(' ')
    }
  }, [])

  const rteChange = debounce(function (value: any) {
    setContent(value)
  }, 10)

  return (
    <>
      <div className='form-social'>
        <Form.Item name={[lang, 'id']} className='hidden'>
          <Input hidden />
        </Form.Item>

        <Form.Item name={[lang, 'articleId']} className='hidden'>
          <Input hidden />
        </Form.Item>

        <Form.Item
          name={[lang, 'title']}
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            {
              required: true,
              whitespace: true,
              message: `please input name of content ${lang.toUpperCase()}`,
            },
          ]}
        >
          <Input size='large' placeholder={`Title ${lang.toUpperCase()}`} />
        </Form.Item>

        <Form.Item
          name={[lang, 'caption']}
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            {
              required: true,
              whitespace: true,
              message: `please input a short description ${lang.toUpperCase()}`,
            },
          ]}
        >
          <Input.TextArea size='large' placeholder='A short description' rows={3} />
        </Form.Item>

        <Form.Item
          name={[lang, 'content']}
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            {
              required: true,
              whitespace: true,
              message: `please input content ${lang.toUpperCase()}`,
            },
          ]}
        >
          {!!content && (
            <Editor
              content={content}
              onChange={(value) => rteChange(value)}
              image={true}
              folder={'article'}
              className='editor-content'
            />
          )}
        </Form.Item>
      </div>
    </>
  )
}

export default FormContent
